import {
    DELEGATE_ALERT,
    DELEGATE_ALERT_SUCCESS,
    DELEGATE_ALERT_FAIL,
    FETCH_DELEGATE_TEAMS,
    FETCH_DELEGATE_TEAMS_SUCCESS,
    FETCH_DELEGATE_TEAMS_FAIL
} from './actionTypes';

const initialState = {
    alertToDelegate: {},
    delegatedAlert: {},
    error: null,
    loading: false,
    loaded: false
};

export function delegateAlertReducer(state = initialState, action) {
    switch (action.type) {
        case DELEGATE_ALERT: {
            return {
                ...initialState,
                alertToDelegate: action.payload,
                loading: true
            };
        }
        case DELEGATE_ALERT_SUCCESS: {
            return {
                ...initialState,
                delegatedAlert: action.payload,
                loaded: true
            };
        }
        case DELEGATE_ALERT_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        default:
            return state;
    }
}

const delegateTeamsInitialState = {
    // [{ id, name }], in the order the server gave them (by name)
    data: [],
    error: null,
    loading: false,
    loaded: false
};

/* The teams to choose from in the dialog that delegates an alert: kept apart from the state of the delegation, which starts over with each one. */
export function delegateTeamsReducer(
    state = delegateTeamsInitialState,
    action
) {
    switch (action.type) {
        case FETCH_DELEGATE_TEAMS:
            return { ...state, loading: true, error: null };
        case FETCH_DELEGATE_TEAMS_SUCCESS:
            return {
                ...state,
                data: action.payload || [],
                loading: false,
                loaded: true
            };
        case FETCH_DELEGATE_TEAMS_FAIL:
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }
}
